import React from 'react';
import ReactDOM from 'react-dom';
import {getJSONFromHtml} from "../../../domain/common";
import { StudioVersePageDM} from "./interfaces";
import CreatorList from '../common/components/creator-list';
import PresetList from '../common/components/preset-list';


const initCustomLists = (StudioVersePageDM : StudioVersePageDM, ImgCdnDomain : string, CreatorsPath: string) => {

    const $presetList = document.querySelectorAll('[data-preset-list]');
    $presetList.forEach($popup => {
        const listID = $popup.getAttribute('data-preset-list');
        const presetSizes = $popup.getAttribute('data-preset-sizes');

        const isNoLazyLoad = $popup.getAttribute('no-lazy-load');

        const presetIDs = StudioVersePageDM.presetsData.sortItems.filter(sortItem => sortItem.listID === Number(listID))
            .sort((a,b) => a.sortID -b.sortID)
            .map(sortItem => sortItem.presetID);

        //If list has items & the list is not lazy load type (LazyLoad lists are loaded on scroll event)
        if(presetIDs.length > 0 && isNoLazyLoad){
            const $placeholder = document.getElementById('list-' + listID);
            ReactDOM.render(
                <PresetList
                    presetListData={ StudioVersePageDM.presetsData }
                    key={ listID }
                    presetsIDs={ presetIDs }
                    presetSizes ={presetSizes}
                    imgCdnDomain={ ImgCdnDomain }
                    creatorsPath={ CreatorsPath }
                    loop={true}
                    // cancelImgLazyload={true}
                />,
                $placeholder
            );

        }

    });
}
const initCreatorsList = (StudioVersePageDM : StudioVersePageDM, ImgCdnDomain : string, CreatorsPath: string) => {
/*
    <div data-creator-list="1" id="creator-list-1" ></div>
*/
    const $creatorList = document.querySelectorAll('[data-creator-list]');
    $creatorList.forEach($popup => {
        const listID = $popup.getAttribute('data-creator-list');
        let creatorIDs = StudioVersePageDM.creatorsData.sortItems.filter(sortItem => sortItem.listID === Number(listID))
            .sort((a,b) => a.sortID -b.sortID)
            .map(sortItem => sortItem.profileID);

        const isNoLazyLoad = $popup.getAttribute('no-lazy-load');

        //If list has items & the list is not lazy load type (LazyLoad lists are loaded on scroll event)
        if(creatorIDs.length > 0 && isNoLazyLoad){
            const $placeholder = document.getElementById('creator-list-' + listID);
            ReactDOM.render(
                <CreatorList key={listID}
                             creatorsIDs={creatorIDs}
                             creatorsPath={CreatorsPath}
                             creatorListData={StudioVersePageDM.creatorsData}
                             imgCdnDomain={ImgCdnDomain}
                             loop={true}

                />,
                $placeholder
            );
        }

    });
}

const init = () => {
    const studioVersePageDM = (getJSONFromHtml(document.getElementById('olp-custom-preset-list-data')) as StudioVersePageDM);
    console.log('studioVersePageDM:',studioVersePageDM);
    const imgCdnDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();
    const creatorsPath = (document.getElementById('creators-relative-path')?.textContent || '')?.trim().toLowerCase();

    initCustomLists(studioVersePageDM, imgCdnDomain, creatorsPath);
    initCreatorsList(studioVersePageDM, imgCdnDomain, creatorsPath);

};

const isScrolledIntoView = (elem : any) => {
    //If the element is about to scrolled into (distance of at least 600 px from the page bottom) return true.
    const rect = elem.getBoundingClientRect();
    if(rect.top - 600 <= window.innerHeight){
        return true;
    }
    return false;
};

window.addEventListener("scroll", (event) => {

    const StudioVersePageDM = (getJSONFromHtml(document.getElementById('olp-custom-preset-list-data')) as StudioVersePageDM);
    const ImgCdnDomain = (document.getElementById('img-cdn-domain')?.textContent || '')?.trim().toLowerCase();
    const CreatorsPath = (document.getElementById('creators-relative-path')?.textContent || '')?.trim().toLowerCase();

    const $presetList = document.querySelectorAll('[data-preset-list]');

    $presetList.forEach($popup => {

        const listID = $popup.getAttribute('data-preset-list');

        //If list element has attribute no-lazy-load="true" --> the list was loaded on page load --> do not load it again
        const isNoLazyLoad = $popup.getAttribute('no-lazy-load');
        if(isNoLazyLoad) return;

        //If the element is NOT about to scrolled into --> do not load it again
        const isScrolledInto = isScrolledIntoView($popup);
        if(!isScrolledInto) return;

        //If the element was already loaded --> do not load it again
        const isLoaded = $popup.getAttribute('loaded');
        if(isLoaded) return;

        //Before loading the list --> mark this list as loaded list
        $popup.setAttribute('loaded',"true");

        const presetIDs = StudioVersePageDM.presetsData.sortItems.filter(sortItem => sortItem.listID === Number(listID))
            .sort((a,b) => a.sortID -b.sortID)
            .map(sortItem => sortItem.presetID);

        if(presetIDs.length > 0){

            const $placeholder = document.getElementById('list-' + listID);
            ReactDOM.render(
                <PresetList
                    presetListData={ StudioVersePageDM.presetsData }
                    key={ listID }
                    presetsIDs={ presetIDs }
                    imgCdnDomain={ ImgCdnDomain }
                    creatorsPath={ CreatorsPath }
                    loop={true}
                    /*cancelImgLazyload={true}*/
                />,
                $placeholder
            );

        }

    });


    const $creatorList = document.querySelectorAll('[data-creator-list]');
    $creatorList.forEach($popup => {

        const listID = $popup.getAttribute('data-creator-list');

        //If list element has attribute no-lazy-load="true" --> the list was loaded on page load --> do not load it again
        const isNoLazyLoad = $popup.getAttribute('no-lazy-load');
        if(isNoLazyLoad) return;

        //If the element is NOT about to scrolled into --> do not load it again
        const isScrolledInto = isScrolledIntoView($popup);
        if(!isScrolledInto) return;

        //If the element was already loaded --> do not load it again
        const isLoaded = $popup.getAttribute('loaded');
        if(isLoaded) return;

        //Before loading the list --> mark this list as loaded list
        $popup.setAttribute('loaded',"true");

        let creatorIDs = StudioVersePageDM.creatorsData.sortItems.filter(sortItem => sortItem.listID === Number(listID))
            .sort((a,b) => a.sortID -b.sortID)
            .map(sortItem => sortItem.profileID);

        if(creatorIDs.length > 0){
            const $placeholder = document.getElementById('creator-list-' + listID);
            ReactDOM.render(
                <CreatorList key={listID}
                             creatorsIDs={creatorIDs}
                             creatorsPath={CreatorsPath}
                             creatorListData={StudioVersePageDM.creatorsData}
                             imgCdnDomain={ImgCdnDomain}
                             loop={true}
                />,
                $placeholder
            );
        }

    });


});
/**
 * entry point
 */
window.addEventListener('DOMContentLoaded', (event) => {
    init();
});
